import { Modal } from 'src/components/common';
import { observer } from 'mobx-react';
import { Box, useToast } from 'braid-design-system';
import { HirerTeamMemberJobAccessProvider } from '@seek/hirer-team-member-job-access';

import { MODAL_NAME } from 'src/constants/modals';
import hirerGraphClient from 'src/graphql/hirer/client';
import * as styles from './TeamMemberAccessModal.css';

import { useStores } from 'src/utils/hooks/useStores';
import { TeamMemberAccess } from './TeamMemberAccess';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';

export const TeamAccessModal = () => {
  const { t } = useTranslations(translations);
  const modalName = MODAL_NAME.TEAM_MEMBER_ACCESS;
  const showToast = useToast();
  const {
    uiStore: { modalStore },
    userStore: { user },
    seekAdvertiserId,
    jobId,
    jobStore: { job },
  } = useStores();

  const removeModal = () => {
    modalStore?.removeModal(modalName);
  };

  const handleSaveSuccess = () => {
    removeModal();
    showToast({
      tone: 'positive',
      message: t('Team access updated'),
      closeLabel: t('Close'),
    });
  };

  return (
    <Modal
      modalStore={modalStore!}
      name={modalName}
      contentClassName={styles.modalContent}
    >
      {() => (
        <Box width="full" paddingY="large">
          <HirerTeamMemberJobAccessProvider
            jobId={jobId.toString()}
            seekAdvertiserId={seekAdvertiserId}
            currentLoginUserId={user.userId?.toString() || ''}
            apolloClient={hirerGraphClient}
          >
            <TeamMemberAccess
              onSubmitSuccess={handleSaveSuccess}
              onCancel={removeModal}
              jobTitle={job?.jobInformation?.title}
              jobId={jobId.toString()}
              userName={user.name}
            />
          </HirerTeamMemberJobAccessProvider>
        </Box>
      )}
    </Modal>
  );
};
export default observer(TeamAccessModal);
